export default __webpack_public_path__ + "static/media/03.61833ffc.jpg";